import './Logo.css';

// Símbolo da C1010 redesenhado em vetor a partir do logo3.png.
export function Simbolo({ className, titulo }) {
    return (
        <svg
            className={className}
            viewBox="0 0 716 1032"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            role={titulo ? 'img' : undefined}
            aria-hidden={titulo ? undefined : true}
        >
            {titulo && <title>{titulo}</title>}
            <polygon points="303,0 303,228 22,228" />
            <polygon points="10,256 309,256 492,502 193,502" />
            <polygon points="193,530 492,530 309,776 10,776" />
            <polygon points="22,804 303,804 303,1032" />
            <polygon points="332,0 716,516 332,1032 332,794 539,516 332,238" />
        </svg>
    );
}

function Logo({ className = '' }) {
    return (
        <span className={`logo ${className}`}>
            <Simbolo className="logo-simbolo" />
            <span className="logo-texto">
                <span className="logo-nome">C1010</span>
                <span className="logo-sub">Sistemas</span>
            </span>
        </span>
    );
}

export default Logo;
